import React, { Component, Fragment } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { withTranslation } from "react-i18next";
import { PageListComponent, HeaderListComponent } from "../../../common/component/Index";
import TranslateButton from '../../../common/component/TranslateButton';
import AutoTranslate from '../../../common/component/AutoTranslate/AutoTranslate';
import * as Func from '../../../../../helpers/functions';
import { FEATURE_FLAGS } from "../../../../../constants/Define";
import DEFINE from "../../../../../constants/Define";

const FormItem = Form.Item;
let permisionActions = {};

const sampleMenuGroup = {
    id: 'group-1',
    groupCode: 'G001',
    groupName: 'Appetizers',
    languageCode: 'vi-VN',
    targetLanguage: [],
    translations: [
        { languageCode: 'vi-VN', name: 'Tieng Viet', isDefault: true },
        { languageCode: 'en-US', name: 'English', isDefault: false },
    ],
};

class MenuSubDetail extends Component {
    state = {
        menuGroup: sampleMenuGroup,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);
    }

    handleChangeName = (event) => {
        const groupName = event.target.value;
        this.setState((prevState) => ({
            menuGroup: {
                ...prevState.menuGroup,
                groupName,
            },
        }));
    };

    handleChangeDetail = (field, value) => {
        this.setState((prevState) => ({
            menuGroup: {
                ...prevState.menuGroup,
                [field]: value,
            },
        }));
    };

    getDefaultLanguageCode = () => {
        const { menuGroup } = this.state;
        const defaultLang = (menuGroup.translations || []).find((item) => item.isDefault);
        return (defaultLang && defaultLang.languageCode) || menuGroup.languageCode || 'vi-VN';
    };

    handleShowTranslate = (language) => {
        if (!language || !language.code) return;
        this.setState((prevState) => {
            const exists = (prevState.menuGroup.translations || []).some(
                (item) => item.languageCode === language.code
            );
            const translations = exists
                ? prevState.menuGroup.translations
                : [
                    ...prevState.menuGroup.translations,
                    { languageCode: language.code, name: '', isDefault: false },
                ];
            return {
                menuGroup: {
                    ...prevState.menuGroup,
                    languageCode: language.code,
                    translations,
                },
            };
        });
    };

    handleExitTranslate = () => {
        this.setState((prevState) => ({
            menuGroup: {
                ...prevState.menuGroup,
                languageCode: this.getDefaultLanguageCode(),
            },
        }));
    };

    handleRemoveTranslate = (language) => {
        if (!language || !language.code) return;
        this.setState((prevState) => {
            const translations = (prevState.menuGroup.translations || []).filter(
                (item) => item.languageCode !== language.code
            );
            const defaultLanguageCode = this.getDefaultLanguageCode();
            const nextLanguageCode =
                prevState.menuGroup.languageCode === language.code
                    ? defaultLanguageCode
                    : prevState.menuGroup.languageCode;
            return {
                menuGroup: {
                    ...prevState.menuGroup,
                    translations,
                    languageCode: nextLanguageCode,
                },
            };
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        // TODO: wire update API next sprint.
    };

    render() {
        const { t, match, location, history } = this.props;
        const { menuGroup } = this.state;
        const menuName = location?.state?.menuName || `Menu ${match.params.menuId || match.params.id}`;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={Func.capitalizeFirstLetter(
                            (`${t('action.update')} ${t('navigation.menu')}`).toLowerCase()
                        )}
                        extraBreadcrumbs={[{ title: menuName }]}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE && (
                            <TranslateButton
                                languages={menuGroup.translations}
                                current={menuGroup.languageCode}
                                onChange={this.handleShowTranslate}
                                onClear={this.handleExitTranslate}
                                onRemove={this.handleRemoveTranslate}
                            />
                        )}
                    />
                    <Card bordered={false}>
                        <Form layout="vertical" onSubmit={this.handleSubmit}>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label={t('item.menuGroup.groupCode')}>
                                        <Input value={menuGroup.groupCode} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label={t('item.menuGroup.groupName')}>
                                        <Input value={menuGroup.groupName} onChange={this.handleChangeName} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <AutoTranslate
                                        className="wrapper-full"
                                        languageCode={menuGroup.languageCode || 'vi-VN'}
                                        targetLanguage={menuGroup.targetLanguage}
                                        onChange={this.handleChangeDetail}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "right" }}>
                                    <Button style={{ marginRight: 8 }} onClick={() => history.goBack()}>
                                        {t('action.back')}
                                    </Button>
                                    <Button 
                                        type="primary" 
                                        htmlType="submit"
                                        disabled={!permisionActions || !permisionActions.allowUpdate}
                                    >
                                        {t('action.update')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

export default withTranslation()(MenuSubDetail);
